module.exports = __webpack_public_path__ + "img/_circleWhiteUser.png?1fa45f9a1861415166b4a78336fd7e77";